import React from "react";
import AllCategoriesTag from "./AllCategoriesTag";
import { MdKeyboardArrowLeft } from "@react-icons/all-files/md/MdKeyboardArrowLeft";

import tags from "../../../components/data/Tags.json";
function Tags() {
  const [active, setactive] = React.useState(false);
  return (
    <div className="sm:-mt-[115px] -mt-[130px] mx-[15px] sm:mx-0">
      <div>
        <div className="flex justify-center items-center">
          <h1 className="font-size text-tertiary text-center">
            All CATEGORIES
          </h1>
        </div>
        <div
          className={
            active
              ? "relative overflow-hidden lg:overflow-visible max-h-[3000px] pb-4 lg:h-fit duration-1000 ease-in-out flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-6 lg:gap-6 items-center justify-start sm:justify-center mt-[32px] "
              : "relative overflow-hidden lg:overflow-visible max-h-[200px] lg:max-h-[1000px] pb-4 lg:h-fit duration-1000 ease-in-out flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-6 lg:gap-6 items-center justify-start sm:justify-center mt-[32px] "
          }
        >
          <div
            className={
              active
                ? "block lg:hidden  bg-gradient-to-t bottom-0 absolute from-secondary to-secondary/0 w-full h-[100px] opacity-50 pointer-events-none duration-500 ease-in-out z-50"
                : "block lg:hidden  bg-gradient-to-t bottom-0 absolute from-secondary to-secondary/0 w-full h-[100px] opacity-100 duration-500 ease-in-out z-50"
            }
          ></div>
          <div
            onClick={() => setactive((prev) => !prev)}
            className={
              active
                ? "absolute block lg:hidden duration-500 ease-in-out  rotate-90 bottom-0 text-tertiary cursor-pointer z-50"
                : "absolute block lg:hidden duration-500 ease-in-out  -rotate-90 bottom-0 text-tertiary cursor-pointer z-50"
            }
          >
            <MdKeyboardArrowLeft />
          </div>
          {tags?.map((tag) => {
            return <AllCategoriesTag key={tag.id} tag={tag.tagName} />;
          })}
        </div>
      </div>
    </div>
  );
}

export default Tags;
